/*
 * TODO make sure to define VUE_SENTRY_DSN= in your .env files
 * */
import Vue from "vue";
import * as Sentry from "@sentry/browser";

if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [
            new Sentry.Integrations.Vue({
                Vue,
                attachProps: true,
            }),
        ],
    });
    console.log("Sentry installed!");
}
